/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { type Meta, type StoryObj } from '@storybook/react-vite';

import { StatusIndicator } from '../../index';
import { StatusIndicatorVariants, StatusIndicatorVariantsSource } from '.';

const componentMeta: Meta<typeof StatusIndicator> = {
  component: StatusIndicator,
  decorators: [
    (Story) => (
      <div className="n-flex n-justify-center">
        <Story />
      </div>
    ),
  ],
  id: 'components-status-indicator',
  parameters: {
    controls: { disable: true },
  },
  tags: ['docsPage'],
  title: 'Components/StatusIndicator',
};

export default componentMeta;
type Story = StoryObj<typeof componentMeta>;

export const Variants: Story = {
  args: {},
  render: StatusIndicatorVariants,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: StatusIndicatorVariantsSource,
      },
    },
  },
};
